import axios from 'axios'
import QueryString from 'qs'
import { useEffect, useMemo, useState, useCallback, MouseEvent } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useLocation, useNavigate } from 'react-router-dom'
import { TopMenu } from '../@types/aboutfishing'
import { ProfileRootType } from '../@types/auth'
import { BannerAccount } from '../@types/home'
import { AdditionalInfo } from '../@types/profile'
import { getProfile, postOpenid } from '../api/auth'
import { getMobileBannerId, getPcBannerId } from '../api/home'
import { getMenu, getToken, getWelcome } from '../api/login'
import { getOrderList } from '../api/orderHistory'
import HeaderTopMenu from '../components/HeaderTopMenu'
import AdSlideModal from '../components/home/AdSlideModal'
import WelcomeModal from '../components/home/WelcomeModal'
import HomeModules from '../components/HomeModules'
import MainCarousel from '../components/MainCarousel'
import { default as ChannelTalkButton } from '../components/myshopping/ChannelTalkButton'
import { useAppContext } from '../components/provider/AppProvider'
import { useCommonContext } from '../components/provider/CommonProvider'
import '../css/home.css'
import { handlePostMessage, sendSetAppsflyerEvent } from '../js/postMessage'
import { getKoreaTime, getParsedLocalStorageItem, getParsedSessionStorageItem } from '../js/script'
import MarketingModal from '../components/home/MarketingModal'
import MarketingCenterModal from '../components/home/MarketingCenterModal'

// 이미지 경로
export const imgURL = '/images'

export default function Home() {
  const [bannerItem, setBannerItem] = useState<BannerAccount[]>([])
  const [adModal, setAdModal] = useState<boolean>(false)
  const [welcomeModal, setWelcomeModal] = useState<boolean>(true)
  const [welcome, setWelcome] = useState<boolean>(false)
  const [parseData, setParseData] = useState<AdditionalInfo | null>(null)
  const [popupCheck, setPopupCheck] = useState<boolean>(true)
  const [welcomeGiveup, setWelcomeGiveup] = useState<boolean>(false)
  const [homeMenu, setHomeMenu] = useState<TopMenu[]>([])
  const [bannerSort, setBannerSort] = useState<any>([])
  const [first, setFirst] = useState<boolean>(false)
  const [userData, setUserData] = useState<ProfileRootType>()
  const [marketingModal, setMarketingModal] = useState<boolean>(true)
  const [marketingGiveUpModal, setMarketingGiveUpModal] = useState<boolean>(false)
  const { isAppView } = useAppContext()
  const { hasAccessToken, setHasAccessToken } = useCommonContext()
  const location = useLocation()
  const navigate = useNavigate()

  // TODO: 현재 컴포넌트가 '/' 해당 path 에서만 사용되는데 currentUrl 이 필요한건지 궁금합니다.
  const currentUrl = useMemo(() => window.location.pathname, [])

  const carouselOnClickHandler = useCallback(
    (e: MouseEvent<HTMLAnchorElement, MouseEvent>, el: any) => {
      const app = getParsedSessionStorageItem('app')
      const getAboutfishingToken = getToken()
      if (app) {
        e.preventDefault()
        if (
          el.banners[0]?.landingUrl.includes('openevent') ||
          el.banners[0]?.landingUrl.includes('outlet') ||
          el.banners[0]?.landingUrl.includes('100wonshop')
        ) {
          handlePostMessage({
            actionType: 'moveToLinkDetail',
            params: { url: `${el.banners[0].landingUrl}?newwebview=true&token=${getAboutfishingToken}` },
          })
        } else {
          if (!el.banners[0]?.landingUrl) return
          handlePostMessage({
            actionType: 'moveToLinkDetail',
            params: {
              url: `${process.env.REACT_APP_SHOP_URL}${el.banners[0]?.landingUrl}?newwebview=true&token=${getAboutfishingToken}`,
            },
          })
        }
      }
      const gtmNavigateClick: DataLayerArgs = {
        dataLayer: {
          event: 'select_content',
          event_info: {
            content_type: '메인_배너형',
            content_id: String(el.banners[0].bannerNo),
            content_name: el.banners[0].name,
          },
        },
      }
      if (isAppView) {
        sendSetAppsflyerEvent({
          eventName: 'select_content',
          eventType: {
            content_type: '메인_배너형',
            content_id: String(el.banners[0].bannerNo),
            content_name: el.banners[0].name,
          },
        })
      } else {
        TagManager.dataLayer(gtmNavigateClick)
      }
    },
    [isAppView]
  )

  useEffect(() => {
    const welcomeBol = getParsedSessionStorageItem('welcomeGiveup')
    if (welcomeBol) {
      setWelcomeGiveup(true)
    } else {
      window.sessionStorage.setItem('welcomeGiveup', JSON.stringify(false))
      setWelcomeGiveup(false)
    }
  }, [])

  useEffect(() => {
    const popupBol = getParsedSessionStorageItem('closePopup')
    if (popupBol) {
      setPopupCheck(false)
    } else {
      window.sessionStorage.setItem('closePopup', JSON.stringify(false))
    }
  }, [])

  // 텍스트 배너 닫기 버튼
  useEffect(() => {
    const bannerText = document.querySelector('.banner_text') as HTMLElement
    const bannerBtnClose = document.querySelector('.banner_text button')

    const handleClick = () => {
      if (bannerText) {
        bannerText.style.display = 'none'
      }
    }
    bannerBtnClose?.addEventListener('click', handleClick)
    return () => {
      bannerBtnClose?.removeEventListener('click', handleClick)
    }
  }, [])

  useEffect(() => {
    const userAgentFromClient = navigator.userAgent
    if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(userAgentFromClient)
  }, [])

  useEffect(() => {
    if (hasAccessToken) {
      getWelcome()
        .then((res) => {
          if (res.data.accumulation) {
            setWelcome(false)
          } else {
            setWelcome(true)
          }
        })
        .catch((error) => {})
    }
  }, [])

  useEffect(() => {
    if (!hasAccessToken) {
      setFirst(true)
    } else {
      setFirst(false)
    }
  }, [hasAccessToken])

  useEffect(() => {
    // FIXME: deps 가 [location] 은 모아주시던지 이것을 사용하는 다른 컴포넌트로 옮겨주세요.
    const query = QueryString.parse(location.search, {
      ignoreQueryPrefix: true,
    })
    if (query.token) {
      window.localStorage.setItem('aboutAccessToken', JSON.stringify(query.token))
      postOpenid(query.token as string).then((res) => {
        window.localStorage.setItem(`accessToken`, JSON.stringify(res.data.accessToken))
        navigate('/')
        setHasAccessToken(true)
      })
    }
  }, [location])

  useEffect(() => {
    const oneDayCheck = getParsedLocalStorageItem('lastRunDateExchanging')
    const getTime = async () => {
      const value = await getKoreaTime()
      setAdModal(oneDayCheck !== value)
    }
    getTime()
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [menuRes, bannerRes] = await axios.all([getMenu(), isMobile ? getMobileBannerId() : getPcBannerId()])
        setHomeMenu(menuRes.data.topMenus)
        setBannerSort(bannerRes.data[0]?.accounts)
      } catch (err) {
        console.log(err)
      }
    }

    fetchData()
  }, [isMobile])

  useEffect(() => {
    const fetchOrderAndProfile = async () => {
      if (hasAccessToken) {
        try {
          const [orderRes, profileRes] = await axios.all([getOrderList(), getProfile()])

          if (orderRes.data.items.length !== 0) setFirst(true)
          const parseData = JSON.parse(profileRes.data.additionalInfo)
          setUserData(profileRes.data)
          setParseData(parseData)
        } catch (err) {
          console.log(err)
        }
      }
    }

    fetchOrderAndProfile()
  }, [hasAccessToken])

  useEffect(() => {
    bannerSort.sort((a: any, b: any) => {
      return Number(b.accountName) - Number(a.accountName)
    })
    setBannerItem(bannerSort)
    // window.scrollTo(0, 1);
  }, [bannerSort, location])

  useEffect(() => {
    if (userData === undefined) {
      const currentDomain = window.location.hostname

      const channelSessionCookieNumber = document.cookie.match(/ch-session-(\d+)=/)
      if (channelSessionCookieNumber?.length && channelSessionCookieNumber[1]) {
        removeCookie(`ch-session-${channelSessionCookieNumber[1]}`, {
          domain: currentDomain === 'localhost' ? currentDomain : '.aboutfishing.kr',
          path: '/',
        })
      }
    }
  }, [userData])

  function removeCookie(name: any, options = {}) {
    const { domain, path }: any = options

    document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; ${path ? `path=${path};` : ''} ${
      domain ? `domain=${domain};` : ''
    }`
  }

  // 뒤로가기 시, 스크롤 유지
  // useEffect(() => {
  //   const val = getPrevScroll();

  //   if (val) {
  //     const handleScroll = () => {
  //       const maxScroll = document.documentElement.scrollHeight;

  //       // 최대 스크롤 높이가 val보다 커지는 순간 실행
  //       if (maxScroll > Number(val)) {
  //         setTimeout(() => {
  //           prevScrollProcess();
  //         }, 2000);
  //         cleanup();
  //       }
  //     };

  //     const cleanup = () => {
  //       window.removeEventListener('scroll', handleScroll);
  //       window.removeEventListener('resize', handleScroll);
  //       if (observer) observer.disconnect();
  //     };

  //     const observer = new MutationObserver(() => {
  //       handleScroll(); // DOM 변경 시 스크롤 상태 확인
  //     });

  //     observer.observe(document.body, {
  //       childList: true, // 자식 요소 변경 감지
  //       subtree: true, // 하위 노드 감지
  //       attributes: true, // 속성 변경 감지
  //     });

  //     window.addEventListener('scroll', handleScroll);
  //     window.addEventListener('resize', handleScroll);
  //     return cleanup;
  //   }
  // }, []);

  return (
    <>
      {/* <div className='main_wrap home'> */}
      <div className={currentUrl === '/' && isAppView ? 'main_wrap home main_page app' : 'main_wrap home main_page'}>
        {/* 기기에 따라 화면이 늘어남 */}
        {/* <HeaderResponse />
        <MainTabMenuRes /> */}

        {/* <MainTabMenu /> */}
        <div className={currentUrl === '/' && isAppView ? 'home_wrap app' : 'home_wrap'}>
          <main>
            {/* 홈모듈 */}
            {/* 상단 배너 문구 */}
            {/* 상단 전시카테고리 */}
            <HeaderTopMenu homeMenu={homeMenu} isFirstVisit={first} />

            {/* 추후 살릴예정 지우지 말아주세요 */}
            {/* <TickerSlide
              setCloseCheck={setCloseCheck}
              closeCheck={closeCheck}
            /> */}

            {/* 메인 배너 슬라이더 */}
            <MainCarousel items={bannerItem} onClick={carouselOnClickHandler} />

            {/* 테마별 카테고리 */}

            {/* 홈모듈 */}
            <div className='module_wrap'>
              <HomeModules />
            </div>
          </main>
        </div>
      </div>
      {/* <button
        type='button'
        onClick={() => {
          setadModal(true);
        }}
      >
        광고 슬라이드 팝업
      </button> */}
      {adModal && !isAppView && popupCheck && <AdSlideModal setAdModal={setAdModal} />}
      {location.pathname === '/' && <ChannelTalkButton></ChannelTalkButton>}
      {/* <button
        type='button'
        onClick={() => {
          navigate('/openevent');
        }}
      >
        쇼핑몰 새단장 오픈 기념 이벤트
      </button> */}

      {/* 웰컴 기프트 팝업 */}
      {welcome && welcomeModal && !welcomeGiveup && hasAccessToken && (
        <WelcomeModal setWelcomeModal={setWelcomeModal} />
      )}
      {welcome && !welcomeModal && !welcomeGiveup && hasAccessToken && marketingModal && isMobile && (
        <MarketingModal setMarketingModal={setMarketingModal}></MarketingModal>
      )}
      {welcome && !welcomeModal && !welcomeGiveup && hasAccessToken && marketingModal && !isMobile && (
        <MarketingCenterModal setMarketingModal={setMarketingModal}></MarketingCenterModal>
      )}
    </>
  )
}
